var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Water",
    clipPath: "url(#clip0_8609_754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.0022 18.7939C44.6468 17.6501 43.8078 16.7145 42.7137 16.2203L24.9307 8.18853C23.8366 7.69437 22.5799 7.68339 21.4868 8.17299C20.3936 8.66259 19.5451 9.59661 19.1811 10.731L12.3064 31.9494C11.3758 34.8316 12.7462 37.9181 15.5045 39.164L25.7212 43.7784C28.4796 45.0243 31.7083 43.9964 33.2484 41.4081L44.6228 22.2219C45.2402 21.1835 45.373 19.9447 45.0176 18.8009L45.0022 18.7939Z",
    fill: "#232C35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M18.4167 31.3361C17.2037 30.5362 15.1896 30.9053 13.8751 31.9634C12.349 33.9527 13.867 35.5758 14.2952 36.5728C14.7234 37.5698 20.6313 40.0421 21.7277 40.6713C22.8241 41.3004 27.8983 43.1185 28.9872 43.2085C30.0761 43.2985 33.3454 39.1502 33.4346 38.1191C33.5238 37.0879 29.3956 38.1698 28.4461 36.9374C27.4967 35.705 27.5859 34.6739 26.2195 33.2532C24.8531 31.8324 23.3196 33.2827 21.8175 33.2739C20.3154 33.2651 20.35 32.6111 18.4167 31.3361Z",
    fill: "#C3F483"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.0022 18.7939C44.6468 17.6501 43.8078 16.7145 42.7137 16.2203L24.9307 8.18853C23.8366 7.69437 22.5799 7.68339 21.4868 8.17299C20.3936 8.66259 19.5451 9.59661 19.1811 10.731L12.3064 31.9494C11.3758 34.8316 12.7462 37.9181 15.5045 39.164L25.7212 43.7784C28.4796 45.0243 31.7083 43.9964 33.2484 41.4081L44.6228 22.2219C45.2402 21.1835 45.373 19.9447 45.0176 18.8009L45.0022 18.7939ZM43.1514 21.3718L31.777 40.558C30.6774 42.4176 28.3673 43.1368 26.3949 42.2459L16.1781 37.6314C14.2057 36.7406 13.2404 34.5235 13.9016 32.4844L20.7763 11.2659C20.9916 10.5839 21.5066 10.0187 22.1608 9.72049C22.8304 9.42921 23.5721 9.43023 24.2347 9.72951L42.0023 17.7544C42.6649 18.0536 43.156 18.6094 43.3802 19.3044C43.6043 19.9993 43.5123 20.737 43.136 21.3648L43.1514 21.3718Z",
    fill: "#C3F483"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8609_754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.5809,
    height: 40.5809,
    fill: "white",
    transform: "translate(17.0703) rotate(24.3067)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterRight);
export default __webpack_public_path__ + "static/media/water-right.f44ae2365669218c133e115c6d3fba24.svg";
export { ForwardRef as ReactComponent };